import { withStyles } from '@material-ui/core';

import { styles } from './AppMenuButton.styles';
import AppMenuButton from './AppMenuButton';

const AppMenuButtonContainer = withStyles(styles)(AppMenuButton);

export default AppMenuButtonContainer;
